// Notions
export const NOTION_PLAYER_MASTERING_REQUIRED_XP = 500; // 1000

// Exercises
export const SESSION_MAX_EXERCICES = 7;
export const SESSION_NUMBER_EXERCICES_FOR_ENCOURAGEMENTS = 4;

// TimeTracking
export const TIME_TRACKING_MAX_TIME_SAVE = 30 * 1000; // we save each 30 sec spent
